import { CONTACT_EMAIL, LOGO_MARK_URL, NAV_LINKS } from "@/lib/constants";
import { useNavHandler } from "@/hooks/useNavHandler";

export const Footer = () => {
  const year = new Date().getFullYear();
  const nav = useNavHandler();

  return (
    <footer
      data-testid="site-footer"
      className="bg-primary text-primary-foreground pt-20 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_MARK_URL}
                alt="Duneworth"
                className="h-11 w-11 object-contain"
              />
              <span className="font-serif text-2xl tracking-[0.18em] uppercase">
                Duneworth
              </span>
            </div>
            <p className="text-base text-primary-foreground/70 max-w-sm leading-relaxed">
              Operating company for modern software platforms.
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="text-[11px] uppercase tracking-[0.3em] text-accent font-semibold mb-6">
              Navigate
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={nav(link.href)}
                    data-testid={`footer-nav-${link.label.toLowerCase()}`}
                    className="text-sm text-primary-foreground/80 hover:text-accent transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-accent font-semibold mb-6">
              Contact
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email-link"
              className="font-serif text-xl sm:text-2xl text-primary-foreground hover:text-accent transition-colors duration-300 break-all"
            >
              {CONTACT_EMAIL}
            </a>
            <p className="mt-6 text-xs uppercase tracking-[0.3em] text-primary-foreground/55">
              Selective · Disciplined · Long-term
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-primary-foreground/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-primary-foreground/55">
            © {year} Duneworth. All rights reserved.
          </p>
          <p className="text-[11px] uppercase tracking-[0.3em] text-primary-foreground/45">
            An operating company
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
